import { useSelector } from 'react-redux'

import { LocationState, RegionState } from './reducer'
import queryString from 'query-string'
import { AppState } from 'common/store'
import { CountryCode, euMembers } from 'common/data/location-detection/country-codes'

export interface LocationStateProps {
    geoLocation: LocationState
}

export interface LocationStateProp {
    geoLocation: LocationState
}

export type AustralianMarketCodes = 'NSW' | 'VIC' | 'QLD' | 'SA' | 'WA' | 'TAS' | 'NT'
const validLocations = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'NT']

export function isValidMarketCode(code: string = ''): code is AustralianMarketCodes {
    return validLocations.includes(code.toUpperCase())
}

export interface LocationResponse {
    ip: string
    postcode?: string
    state?: string
    city?: string
    country?: string
}

export const retrieveLocationQueryString = (location: Location): RegionState => {
    const query: { location?: string } = queryString.parse(location.search)
    const locationQS = typeof query.location === 'string' ? query.location.toUpperCase() : undefined

    return {
        userSelectedRegion: isValidMarketCode(locationQS) ? locationQS : 'NSW',
    }
}

export type MarketCodeTypes = AustralianMarketCodes | false

export type AustralianMarketCodeLabels = { [key in AustralianMarketCodes]: string }

export const marketCodeLabels: AustralianMarketCodeLabels = {
    NSW: 'Sydney, NSW',
    VIC: 'Melbourne, VIC',
    QLD: 'Queensland', // as per P19-701, it was decided not to have 'Brisbane, QLD'
    WA: 'Perth, WA',
    SA: 'Adelaide, SA',
    TAS: 'Hobart, TAS',
    NT: 'Darwin, NT',
}

export const useLocationState = () => {
    const { countryCode, region, userSelectedRegion } = useSelector<AppState, LocationState>(
        state => state.geoLocation
    )

    return { countryCode, region, userSelectedRegion }
}

export function isEuMember(countryCode: CountryCode | undefined) {
    if (!countryCode) return true
    return euMembers.includes(countryCode)
}

export function useIsEuMemberState() {
    return isEuMember(useLocationState().countryCode)
}
